/* ==========================================================================
 *  Function: Add navingation scroll
 * ======================================================================= */

var windowScrollTop;
var windowWidth;
var windowHeight;


if ($('.js-hero-side-form').length){
	var heroSideForm = $('.js-hero-side-form');
	var adviceSection;
	var adviceSectionHeight;
}

function fn_parts_resize(){
	windowScrollTop = $(window).scrollTop();
	windowWidth = $(window).width();
	windowHeight = $(window).height();


	if ($('.js-hero-side-form').length && windowWidth > bp_medium){
		adviceSection = $('.js-advice-section');
		adviceSectionHeight = adviceSection.innerHeight();
		heroSideForm.css('margin-bottom', -(adviceSectionHeight + 20));
	}
}
